import { runInAction, toJS } from "mobx";
import { observer } from "mobx-react-lite";
import React, { useEffect, useCallback, useMemo } from "react";
import { deepClone } from "../../../helpers/objectHelper";
import CustomInput from "../../components/CustomInput";
import { inputValidator } from "../../helpers/inputValidator.helper";

export const Text = observer((props) => {
  const { settings, environment, subLabel, label, orders, updateOrder, activePersonNo, validity, question, validate } = props;
  const { required, prefixClassName, type, displayType, validationType, hidden, readonly } = settings;

  const orderList = useMemo(() => toJS(orders), [orders]);

  const getTextValue = () => {
    const activeOrder = orderList[activePersonNo];
    const activeAnswer = activeOrder?.answer?.find((a) => a.questionId === question.questionId);
    const activeRow = activeAnswer?.answerRow?.find((ar) => !ar.questionOptionId && !ar.deleted);
    return activeRow?.text || "";
  };

  const answerText = getTextValue();

  const validateText = useCallback(() => {
    const { requiredMin, requiredMax } = question;

    let isValid = true;
    let reason = "";

    if (readonly || hidden) {
      isValid = true;
    } else if (required && answerText.length == 0) {
      isValid = false;
      reason = "required";
    } else if (requiredMin > 0 && answerText.length > 0 && answerText.length < requiredMin) {
      isValid = false;
      reason = "minLengthText";
    } else if (requiredMax > 0 && answerText.length > requiredMax) {
      isValid = false;
      reason = "maxLengthText";
    } else if (validationType) {
      isValid = inputValidator(answerText, validationType);
      reason = validationType;
    }

    runInAction(() => {
      validity.valid = isValid;
      validity.reason = reason;
    });
  }, [answerText, question, validity, validate]);

  useEffect(() => {
    validateText();
  }, [orderList, activePersonNo, validateText]);

  const handleChange = (value, optionId) => {
    let order = deepClone(orderList[activePersonNo]);
    if (!order.answer) {
      order.answer = [];
    }
    let answer = order.answer.find((a) => a.questionId == question.questionId);
    if (!answer) {
      answer = {
        answerId: 0,
        interactionKey: null,
        orderId: 0,
        questionId: question.questionId,
        answerRow: [],
      };
      order.answer.push(answer);
    }
    if (!answer.answerRow) {
      answer.answerRow = [];
    }
    if (value === true && question.requiredMax === 1) {
      answer.answerRow.map((ar) => {
        ar.deleted = true;
      });
    }
    let row = answer.answerRow.find(() => true);
    if (row) {
      row.text = value;
    } else {
      answer.answerRow.push({
        answerId: answer.answerId,
        answerRowId: 0,
        questionOptionId: optionId,
        text: value,
        deleted: false,
      });
    }
    answer.answerRow = answer.answerRow.filter((ar) => {
      return !ar.deleted;
    });
    order.answer[order.answer.indexOf(order.answer.find((a) => a.questionId == question.questionId))] = answer;
    updateOrder(order);
    validateText();
  };

  const isValid = useMemo(() => {
    if (answerText.length > 0 && validity?.valid === false) return false;
    else if (answerText.length > 0 && validity?.valid === true) return true;
    else if (validate && validity?.valid === false) return false;
    return undefined;
  }, [validity?.valid, validate, answerText]);

  return (
    <CustomInput
      {...{ ...settings, ...props }}
      required={required}
      valid={isValid}
      lang={environment.lang}
      prefixClassName={settings?.imitateField ? "cms-field" : prefixClassName + ` ${type}`}
      onChange={(e) => handleChange(e.target.value)}
      displayType={displayType}
      settings={settings}
      label={label}
      value={getTextValue()}
      subLabel={subLabel}
    />
  );
});
